export default __webpack_public_path__ + "static/media/portrait.2985519e.jpg";